import React from 'react'
import { ErrorMessage } from 'formik'
import './StyledErrorMessage.scss'

const StyledErrorMessage = ({ name }) => {
  return <ErrorMessage name={name} component="div" className="input-error" />
}

export default StyledErrorMessage
